import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { NavItemType, SgNavItemDefContext, SgNavItemDefControllerContext } from '@sg/common';
import { animate, state, style, transition, trigger } from '@angular/animations';

/**
 * An implementation of a menu item for `SgNavMenuContainerComponent`.
 * This is a direct implementation with support for counters.
 */
@Component({
  selector: 'sg-nav-menu-item',
  templateUrl: './nav-menu-item.component.html',
  styleUrls: ['./nav-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('flyInOut', [
      state('in', style({ width: '*' })),
      transition(':enter', [style({ width: 0 }), animate('0.3s ease-in-out')]),
      transition(':leave', [animate('0.3s ease-in-out', style({ width: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class SgNavMenuItemComponent implements OnInit, SgNavItemDefContext {
  @Input() mi: NavItemType;
  @Input() ctrl: SgNavItemDefControllerContext;
  @Input() isGroup: boolean;
  @Input() expanded: boolean;
  @Input() badge: string | number;
  @Input() customAppCssClass?: string;

  @Output() onInit = new EventEmitter<SgNavMenuItemComponent>();

  get numberBadge(): number {
    return typeof this.badge === 'number' ? this.badge : parseInt(this.badge, 10);
  }

  ngOnInit(): void {
    this.onInit.emit(this);
  }
}
